import _ from 'lodash';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { Alert as AlertBase } from '@deerplusofficial/pos-components';
import { withClient } from '@deerplusofficial/pos-hoc';
import { createCancelToken } from '@deerplusofficial/pos-helper';

const Alert = AlertBase.mixin({
  type: 'question',
  showCancelButton: true,
  showLoaderOnConfirm: true,
});

export default () => Component =>
  withClient()(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithPrintInvoice');

      componentWillUnmount() {
        !_.isUndefined(this.cancelPrintInvoice) && this.cancelPrintInvoice();
        !_.isUndefined(this.cancelRePrintInvoice) &&
          this.cancelRePrintInvoice();
      }

      onInvoicePrint = async ({ orderId, refetch = _.identity }) => {
        const {
          client: { POSApi, onError },
        } = this.props;

        const { value: payload } = await Alert.fire({
          titleText: '確定要開立電子發票？',
          preConfirm: async () => {
            try {
              return await POSApi.post(`/orders/${orderId}/invoices`, null, {
                cancelToken: createCancelToken(this.cancelPrintInvoice),
              });
            } catch (error) {
              return error;
            }
          },
        });

        if (!payload) return;

        _.size(payload.data)
          ? Alert.fire({
              title: '成功開立發票',
              type: 'success',
              preConfirm: refetch,
            })
          : onError(payload);
      };

      onInvoiceRePrint = async ({ invoiceId, refetch = _.identity }) => {
        const {
          client: { POSApi, onError },
        } = this.props;

        const { value: payload } = await Alert.fire({
          titleText: '確定要補開電子發票？',
          preConfirm: async () => {
            try {
              return await POSApi.post(`/print/invoices/${invoiceId}`, null, {
                cancelToken: createCancelToken(this.cancelRePrintInvoice),
              });
            } catch (error) {
              return error;
            }
          },
        });

        if (!payload) return;

        _.size(payload.data)
          ? Alert.fire({
              title: '成功補開發票',
              type: 'success',
              preConfirm: refetch,
            })
          : onError(payload);
      };

      render() {
        return (
          <Component
            onInvoicePrint={this.onInvoicePrint}
            onInvoiceRePrint={this.onInvoiceRePrint}
            {...this.props}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withPrintInvoice.js